import React from 'react';
import { Radio as ChakraRadio } from '@chakra-ui/react';
import { CoreRadioProps } from './types';
import { OptionLabel } from '../OptionLabel';

export const Radio = React.forwardRef<HTMLDivElement, CoreRadioProps>(
  ({ children, label, helpText, tooltip, ...rest }: CoreRadioProps, ref: React.ForwardedRef<HTMLDivElement>) => {
    return (
      <ChakraRadio ref={ref} {...rest}>
        <OptionLabel label={label} helpText={helpText} tooltip={tooltip}>
          {children}
        </OptionLabel>
      </ChakraRadio>
    );
  }
);
Radio.displayName = 'radio';
